/* eslint-disable formatjs/enforce-id */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  // Static Texts
  nextButton: {
    id: '9+Ddtu',
    defaultMessage: 'Next',
  },
  previousButton: {
    id: 'JJNc3c',
    defaultMessage: 'Previous',
  },
  sliderLow: {
    id: '477I0g',
    defaultMessage: 'Low',
  },
  sliderMedium: {
    id: 'ovJ26C',
    defaultMessage: 'Medium',
  },
  sliderHigh: {
    id: 'AxMhQr',
    defaultMessage: 'High',
  },
  // steps content
  introTitle: {
    id: 'OP8vfe',
    defaultMessage: 'Take the assessment',
  },
  introCopy: {
    id: '74dTvv',
    defaultMessage: `According to our survey results, 15% of organizations are AI Leaders and the remaining 85% are AI Learners. Take our assessment to discover where you fall on the spectrum. Based on your answers, you'll get expert advice on how to achieve AI maturity.`,
  },
  introCopy2: {
    id: '74dTvv',
    defaultMessage: `By taking this assessment quiz, you will be able to find out whether you’re in the vanguard of AI Leaders, or if you’re in the 85% of organizations—AI Learners—who need a little push to start seeing better results. Based on your results you’ll get expert advice on how to become an AI Leader or, if you already are one, how to stay on top.`,
  },
  introButton: {
    id: 'SR2+Sb',
    defaultMessage: 'Start',
  },
  //questions sidebar
  qSideTitel: {
    id: 'dioee',
    defaultMessage: 'Quiz title, will always be fixed',
  },
  qSideDescription: {
    id: 'dioee',
    defaultMessage:
      'Description of the quiz, estimated time to finish, and reward for user in the end described here',
  },
  // question 01 data
  q1Title: {
    id: 'nMmztR',
    defaultMessage: `Which of the following best describes your company’s overall AI strategy?`,
  },
  q1subTitle: {
    id: 'nMmztR',
    defaultMessage: `Select one response.`,
  },
  option1Q1: {
    id: 'A6kuBJ',
    defaultMessage: `My company does not have a formal strategy at this time.`,
  },
  option2Q1: {
    id: 'O5FA5z',
    defaultMessage: `My company is developing an AI strategy, but it is in early stages.`,
  },
  option3Q1: {
    id: 'J5lTSu',
    defaultMessage: `My company has an AI strategy that is focused on limited/specific use cases.`,
  },
  option4Q1: {
    id: '8NdSGu',
    defaultMessage:
      'My company has a holistic strategy for using AI broadly across the company.',
  },
  // question 02 data
  q2Title: {
    id: '12uQsv',
    defaultMessage: `In general, how aggressive would you say your company has been in making investments in AI?`,
  },
  option1Q2: {
    id: '6l/Auj',
    defaultMessage: `Not at all aggressive`,
  },
  option2Q2: {
    id: 'pC+SlK',
    defaultMessage: `Not very aggressive`,
  },
  option3Q2: {
    id: 'VRxnaf',
    defaultMessage: `Moderately aggressive`,
  },
  option4Q2: {
    id: 'MHXvQj',
    defaultMessage: `Very aggressive`,
  },
  // question 03 data
  q3Title: {
    id: 'eZidQC',
    defaultMessage: `Which of the following AI-related use cases is your company making use of?`,
  },
  degree0Q3: {
    id: 'yW6G93',
    defaultMessage: `Unsure`,
  },
  degree1Q3: {
    id: 'yW6G93',
    defaultMessage: `Not currently using AI in this area`,
  },
  degree2Q3: {
    id: '+xTjpj',
    defaultMessage: `Evaluating use of AI in this area`,
  },
  degree3Q3: {
    id: 'InATL+',
    defaultMessage: `Limited use of AI in this area`,
  },
  degree4Q3: {
    id: '8CWM+w',
    defaultMessage: `Widespread use of AI in this area`,
  },
  option1Q3: {
    id: 'odoepw',
    defaultMessage: 'Software programming/application development',
  },
  option2Q3: {
    id: 'odoepw',
    defaultMessage: 'Improving customer experience',
  },
  option3Q3: {
    id: 'odoepw',
    defaultMessage: 'IT operations/automation',
  },
  option4Q3: {
    id: 'odoepw',
    defaultMessage: 'Advanced cybersecurity',
  },
  option5Q3: {
    id: 'odoepw',
    defaultMessage: 'Virtual assistants for internal applications',
  },
  // question 04 data
  q4Title: {
    id: 'eZidQC',
    defaultMessage: `Which of the following areas of value are most relevant for your company's AI implementations?`,
  },
  q4subTitle: {
    id: 'nMmztR',
    defaultMessage: `Select 5 areas.`,
  },
  option1Q4: {
    id: 'PBHk8x',
    defaultMessage: 'Enable new sources of revenue',
  },
  option2Q4: {
    id: 'PBHk8x',
    defaultMessage: 'Better differentiate products or services',
  },
  option3Q4: {
    id: 'PBHk8x',
    defaultMessage: 'Improve time to market for new offerings',
  },
  option4Q4: {
    id: 'PBHk8x',
    defaultMessage: 'Increase staff productivity',
  },
  option5Q4: {
    id: 'PBHk8x',
    defaultMessage: 'Reduce staff costs',
  },
  option6Q4: {
    id: 'PBHk8x',
    defaultMessage: 'Streamline work processes/remove bottlenecks',
  },
  option7Q4: {
    id: 'PBHk8x',
    defaultMessage: 'Improve supply chain efficiency',
  },
  option8Q4: {
    id: 'PBHk8x',
    defaultMessage: 'Reduce manufacturing costs',
  },
  option9Q4: {
    id: 'PBHk8x',
    defaultMessage: 'Improve raw material utilization',
  },
  option10Q4: {
    id: 'PBHk8x',
    defaultMessage: 'Make corporate strategy more nimble',
  },
  option11Q4: {
    id: 'PBHk8x',
    defaultMessage: 'Reduce risk/loss (e.g., fraud protection)',
  },
  option12Q4: {
    id: 'PBHk8x',
    defaultMessage: 'Improve cybersecurity / resilience',
  },
  option13Q4: {
    id: 'PBHk8x',
    defaultMessage: 'Improve customer satisfaction/engagement and retention',
  },
  option14Q4: {
    id: 'PBHk8x',
    defaultMessage: 'Improve marketing effectiveness',
  },
  option15Q4: {
    id: 'PBHk8x',
    defaultMessage: 'Improve sales effectiveness and customer acquisition',
  },
  option16Q4: {
    id: 'PBHk8x',
    defaultMessage: 'Unlock staff creativity',
  },
  // question 05 data
  q5Title: {
    id: 'H8R2IC',
    defaultMessage:
      'How much improvement would you say your company’s AI implementations have delivered to date?',
  },
  degree0Q5: {
    id: 'foff',
    defaultMessage: 'Have not yet begun to implement',
  },
  degree1Q5: {
    id: 'yW6G95',
    defaultMessage: `No improvement (0%)`,
  },
  degree2Q5: {
    id: '+xTjpj',
    defaultMessage: `Minimal improvement (1%–10%)`,
  },
  degree3Q5: {
    id: 'InATL+',
    defaultMessage: `Slight improvement (11%–25%)`,
  },
  degree4Q5: {
    id: '8CWM+w',
    defaultMessage: `Moderate improvement (26%–50%)`,
  },
  degree5Q5: {
    id: '8CWM+w',
    defaultMessage: `Significant improvement (>50%)`,
  },
  option1Q5: {
    id: 'PBHk8x',
    defaultMessage: 'AI enabled search engines',
  },
  option2Q5: {
    id: '36XRzv',
    defaultMessage: 'Robotics/autonomous devices/process automation',
  },
  option3Q5: {
    id: 'HMv/M+',
    defaultMessage: 'Image/facial recognition/detection',
  },
  option4Q5: {
    id: 'HMv/M+',
    defaultMessage: 'Improving customer experience',
  },
  option5Q5: {
    id: 'HMv/M+',
    defaultMessage: 'Building “smart” products',
  },
  // question 06
  q6Title: {
    id: 'Lim4Ig',
    defaultMessage: `To what extent do you agree or disagree with the following statement `,
  },
  q6Statement: {
    id: 'xidso',
    defaultMessage: '“My company already has expertise in-house to adopt AI.”',
  },
  option1Q6: {
    id: 'GnXI+G',
    defaultMessage: `Strongly disagree`,
  },
  option2Q6: {
    id: '7edQdH',
    defaultMessage: `Somewhat disagree`,
  },
  option3Q6: {
    id: 'O2RnxI',
    defaultMessage: `Somewhat agree`,
  },
  option4Q6: {
    id: '+gMdkn',
    defaultMessage: `Strongly agree`,
  },
  // question 7
  q7Title: {
    id: 'Gz40K7',
    defaultMessage: `To what extent do you agree or disagree with the following statement?`,
  },
  q7Statement: {
    id: 'xidso',
    defaultMessage:
      '“Overall, I feel my company is making the right investments and has/will have the right infrastructure to successfully deploy AI.”',
  },
  option1Q7: {
    id: 'GnXI+G',
    defaultMessage: `Strongly disagree`,
  },
  option2Q7: {
    id: '7edQdH',
    defaultMessage: `Somewhat disagree`,
  },
  option3Q7: {
    id: 'O2RnxI',
    defaultMessage: `Somewhat agree`,
  },
  option4Q7: {
    id: '+gMdkn',
    defaultMessage: `Strongly agree`,
  },
  // question 8
  q8Title: {
    id: 'Gz40K8',
    defaultMessage: `Thinking about your company’s approach to AI today, how well do each of the following describe your company today?`,
  },
  q8Statement: {
    id: 'xidso',
    defaultMessage: '“We effectively govern our AI applications and data”',
  },
  option1Q8: {
    id: 'GnXI+G',
    defaultMessage: `Does not describe at all`,
  },
  option2Q8: {
    id: '8edQdH',
    defaultMessage: `Does not describe well`,
  },
  option3Q8: {
    id: 'O2RnxI',
    defaultMessage: `Describes somewhat well`,
  },
  option4Q8: {
    id: '+gMdkn',
    defaultMessage: `Describes very well`,
  },
  // question 9
  q9Title: {
    id: 'Gz40K9',
    defaultMessage: `When thinking about your company’s readiness regarding data access and management for AI applications, how close to ready are you to your desired state today? `,
  },
  option1Q9: {
    id: 'GnXI+G',
    defaultMessage: `Not at all`,
  },
  option2Q9: {
    id: '9edQdH',
    defaultMessage: `Somewhat`,
  },
  option3Q9: {
    id: 'O2RnxI',
    defaultMessage: `Very`,
  },
  option4Q9: {
    id: '+gMdkn',
    defaultMessage: `Completely`,
  },
  // success screen data
  successTitle: {
    id: 'ox5yCv',
    defaultMessage: 'Great Job!',
  },
  successCopy: {
    id: '+tqq8R',
    defaultMessage:
      'This was just a small sample of the holistic assessment process that we conduct with clients. Click below to see your results!',
  },
  successButtonBack: {
    id: 'fGKnYe',
    defaultMessage: 'Back to questions',
  },
  successButtonResults: {
    id: 'dwL4wm',
    defaultMessage: 'View results',
  },
  // results data
  resultsTitleLearner: {
    id: 'oWz8km',
    defaultMessage: `You’re an AI Learner!`,
  },
  resultsTitleLeader: {
    id: 'oWz8km',
    defaultMessage: `You’re an AI Leader!`,
  },
  resultsSubTitleLeader: {
    id: 'deieo',
    defaultMessage:
      'Based on this assessment, you are an AI Leader! Congratulations!',
  },
  resultsSubTitleLearner: {
    id: 'deieo',
    defaultMessage: 'Based on this assessment, you are an AI Learner!',
  },
  resultsTextLeader: {
    id: 'fjire',
    defaultMessage: `Congratulations, you’re part of a vanguard — just 15% of the organizations we surveyed — that have been able to rise above the buzz and turn potential into profit. Here are some tips on how you can sharpen your competitive edge:`,
  },
  resultsTextLearner: {
    id: 'fjire',
    defaultMessage: `Learners represent 85% of the organizations we surveyed. Here are some tips on how to become an AI Leader:`,
  },
  resultsDownloadBtn: {
    id: 'fjire',
    defaultMessage: `Download our report`,
  },
  resultsRestartBtn: {
    id: 'fjire',
    defaultMessage: `Request an AI Strategy Briefing`,
  },
  resultsLeaderTip1: {
    id: 'dforoe',
    defaultMessage: 'Follow your action-oriented AI roadmap',
  },
  resultsLeaderTip2: {
    id: 'dforoe',
    defaultMessage:
      'Celebrate AI wins to generate organization-wide excitement',
  },
  resultsLeaderTip3: {
    id: 'dforoe',
    defaultMessage:
      'Maintain a strong data foundation, a hybrid-cloud strategy and a multimodel approach',
  },
  resultsLeaderTip4: {
    id: 'dforoe',
    defaultMessage: 'Continue to get AI applications into production',
  },
  resultsLeaderTip5: {
    id: 'dforoe',
    defaultMessage:
      'Avoid the “perfection trap” by committing to incremental improvement through continuous experimentation',
  },
  resultsLearnerTip1: {
    id: 'dforoe',
    defaultMessage:
      'Develop an action-oriented AI roadmap that facilitates organization-wide buy-in',
  },
  resultsLearnerTip2: {
    id: 'dforoe',
    defaultMessage:
      'Establish a strong data foundation, a hybrid-cloud strategy and a multimodel approach',
  },
  resultsLearnerTip3: {
    id: 'dforoe',
    defaultMessage:
      'Avoid the “perfection trap” by committing to incremental improvement through continuous experimentation',
  },
  resultsLearnerTip4: {
    id: 'dforoe',
    defaultMessage:
      'Develop internal teams and find collaborators that can drive trust and governance',
  },
  resultsFinalMsgLearner: {
    id: 'dkdoe',
    defaultMessage:
      'To learn more about how you can become an AI Leader, download the full AI in Action 2024 report and interact with our AI in Action assistant.',
  },
  resultsFinalMsgLeader: {
    id: 'dkdoe',
    defaultMessage:
      'To learn more practical advice, download the full AI in Action 2024 report and interact with our AI in Action assistant.',
  },
  retryBtn: {
    id: 'dffoep',
    defaultMessage: 'Take again',
  },
});

export default messages;
